'use client';

import { ClerkProvider } from '@clerk/nextjs';
import { usePathname } from 'next/navigation';
import { ReactNode } from 'react';

/**
 * Conditionally wraps children with ClerkProvider.
 *
 * /remote and /tv routes are loaded inside a cross-origin iframe (Volley Hub).
 * In that context Clerk can't access cookies (third-party cookie blocking) and
 * its satellite-domain redirect creates an infinite redirect loop.
 * Skipping ClerkProvider entirely for these routes avoids the issue.
 */
export function ConditionalClerkProvider({ children }: { children: ReactNode }) {
  const pathname = usePathname();
  const isIframeRoute = pathname?.startsWith('/remote') || pathname?.startsWith('/tv');

  if (isIframeRoute) {
    return <>{children}</>;
  }

  return <ClerkProvider>{children}</ClerkProvider>;
}
